module.exports = __webpack_public_path__ + "img/logo.d0a9ddb2.svg";